import { defineStore } from "pinia";

export const useEvaluationPerformanceStore = defineStore('evaluationPerformance', {
    state: () => ({
        evaluationPerformance: {},
        evaluationPerformances: [],
    }),
    actions: {
        setEvaluationPerformance(evaluationPerformance) {
            this.evaluationPerformance = evaluationPerformance
        },
        setEvaluationPerformances(evaluationPerformances) {
            this.evaluationPerformances = evaluationPerformances;
        },
        addEvaluationPerformance(evaluationPerformance) {
            this.evaluationPerformances.unshift(evaluationPerformance)
        },
        updateEvaluationPerformance(evaluationPerformance) {
            let index = this.evaluationPerformances.findIndex(cl => cl.id === evaluationPerformance.id)
            this.evaluationPerformances.splice(index, 1, evaluationPerformance)
        },
        deleteEvaluationPerformance(evaluationPerformance) {
            let index = this.evaluationPerformances.findIndex(cl => cl.id === evaluationPerformance.id)
            this.evaluationPerformances.splice(index, 1)
        },
    },
});